import React from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { useTheme } from '../ThemeContext';
import { useT } from '../i18n/useT';
import { nativeMockStyles, PlatformStage } from './OpenBroNativeMock';

const CustomPlatformSection = () => {
  const { isDark } = useTheme();
  const t = useT();
  const [titleTop, titleBottom] = t.customPlatform.title.split('\\n');

  return (
    <section className="relative mt-20 px-[30px] lg:px-0">
      <div className="mx-auto max-w-[1140px]">
        <div className="flex items-center justify-center gap-5 mt-4 lg:mt-8 w-full">
          <article className="rounded-[40px] w-full flex flex-col justify-end relative overflow-hidden" style={{ background: 'radial-gradient(120% 80% at 50% 0%, #1a2744 0%, #070b14 70%)' }}>
            <PlatformStage />
            <div className="pb-[40px] px-[40px] pt-2">
              <h4 className="text-white text-center max-w-md mx-auto text-[28px] lg:text-[36px] font-bold leading-[1.2]" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>{titleTop}<br />{titleBottom}</h4>
              <p className="text-[rgba(255,255,255,.7)] mt-4 text-center max-w-sm mx-auto text-[15px]" style={{ fontFamily: '"Inter", sans-serif' }} dangerouslySetInnerHTML={{ __html: t.customPlatform.description }} />
            </div>
          </article>
        </div>

        <div className="flex items-center justify-center gap-2 mt-10">
          <button className={`cursor-pointer border-[1px] rounded-full p-2 duration-300 transition-all ${isDark ? 'tech-glow' : ''}`} style={{ color: isDark ? '#E6EBF2' : 'black', borderColor: isDark ? '#E6EBF2' : 'black' }}><ArrowLeft size={16} /></button>
          <div className="w-[75px] h-[4px]" style={{ backgroundColor: isDark ? '#E6EBF2' : '#1B2A4A' }} />
          <div className="w-[75px] h-[4px]" style={{ backgroundColor: isDark ? 'rgba(0,212,255,0.15)' : '#E0E0E0' }} />
          <div className="w-[75px] h-[4px]" style={{ backgroundColor: isDark ? 'rgba(0,212,255,0.15)' : '#E0E0E0' }} />
          <button className={`cursor-pointer border-[1px] rounded-full p-2 duration-300 transition-all ${isDark ? 'tech-glow' : ''}`} style={{ color: isDark ? '#E6EBF2' : 'black', borderColor: isDark ? '#E6EBF2' : 'black' }}><ArrowRight size={16} /></button>
        </div>
      </div>
      <style>{nativeMockStyles}</style>
    </section>
  );
};

export default CustomPlatformSection;
